import { Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';

const useHeaderDafaplusStyles = makeStyles((theme: Theme) =>
  createStyles({
    headerRoot: {
      backgroundColor: '#930102',
      padding: '12px 16px',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      color: '#ffffff',
      fontWeight: 'bold',
      fontSize: '18px',
   
      position: 'relative',
      width: '100%',
      boxSizing: 'border-box',
      minHeight: '60px',
    },
    leftSlot: {
      width: '32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      zIndex: 1,
    },
    logoWrapper: {
      height: 'auto',
      maxWidth: '105px',
    },
    logoCentered: {
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
    },
    logoImg: {
      maxWidth: '105px',
      height: 'auto',
    },
    dafaplusText: {
      fontSize: '22px',
      fontWeight: 'bold',
      letterSpacing: '1px',
      color: '#FFD700',
      fontStyle: 'italic',
      fontFamily: 'Arial, sans-serif',
    },
    actionsBox: {
      display: 'flex',
      gap: '8px',
      alignItems: 'center',
      marginLeft: 'auto',
      width: '32px',
      justifyContent: 'flex-end',
      zIndex: 1,
    },
    navButton: {
      color: '#ffffff !important',
      padding: '4px !important',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.12) !important',
      },
    },
    closeButton: {
      color: '#ffffff',
      padding: '6px',
      '&:hover': {
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
      },
    },
    closeIcon: {
      fontSize: '20px',
    },
    backIcon: {
      fontSize: '20px',
    },
    dialogTitle: {
      fontWeight: 'bold',
    },
  })
);

export default useHeaderDafaplusStyles;
